export default class AccessRight {
    constructor (dto) {
        this.id = 0
        this.name = ''
        this.objectCreate = false
        this.objectRead = false
        this.objectUpdate = false
        this.objectDelete = false
        this.objectDownload = false
        this.objectPrint = false
        this.objectSign = false
        this.objectExternalDistribution = false
        this.documentAttachmentCreate = false
        this.documentAttachmentDelete = false
        this.documentAttachmentRead = false
        this.documentAttachmentUpdate = false
        this.documentAttachmentDownload = false
        this.commentCreate = false
        this.commentRead = false
        this.commentUpdate = false
        this.commentDelete = false
        this.dynamicTablesAddData = false

        if (dto) {
            this.id = dto.Id
            this.name = dto.Name
            this.objectCreate = dto.ObjectCreate
            this.objectRead = dto.ObjectRead
            this.objectUpdate = dto.ObjectUpdate
            this.objectDelete = dto.ObjectDelete
            this.objectDownload = dto.ObjectDownload
            this.objectPrint = dto.ObjectPrint
            this.objectSign = dto.ObjectSign
            this.objectExternalDistribution = dto.ObjectExternalDistribution
            this.documentAttachmentCreate = dto.DocumentAttachmentCreate
            this.documentAttachmentDelete = dto.DocumentAttachmentDelete
            this.documentAttachmentRead = dto.DocumentAttachmentRead
            this.documentAttachmentUpdate = dto.DocumentAttachmentUpdate
            this.documentAttachmentDownload = dto.DocumentAttachmentDownload
            this.commentCreate = dto.CommentCreate
            this.commentRead = dto.CommentRead
            this.commentUpdate = dto.CommentUpdate
            this.commentDelete = dto.CommentDelete
            this.dynamicTablesAddData = dto.DynamicTablesAddData
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            ObjectCreate: this.objectCreate,
            ObjectRead: this.objectRead,
            ObjectUpdate: this.objectUpdate,
            ObjectDelete: this.objectDelete,
            ObjectDownload: this.objectDownload,
            ObjectPrint: this.objectPrint,
            ObjectSign: this.objectSign,
            ObjectExternalDistribution: this.objectExternalDistribution,
            DocumentAttachmentCreate: this.documentAttachmentCreate,
            DocumentAttachmentDelete: this.documentAttachmentDelete,
            DocumentAttachmentRead: this.documentAttachmentRead,
            DocumentAttachmentUpdate: this.documentAttachmentUpdate,
            DocumentAttachmentDownload: this.documentAttachmentDownload,
            CommentCreate: this.commentCreate,
            CommentRead: this.commentRead,
            CommentUpdate: this.commentUpdate,
            CommentDelete: this.commentDelete,
            DynamicTablesAddData: this.dynamicTablesAddData,
        }
    }
}
